import React, { type FC } from 'react';
import { MenuItem, MenuItemLink, OverflowMenu } from 'braid-design-system';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';
import { JOB_APPLICATION_TAB } from 'src/constants/tabs';
import { useAppConfig } from 'src/constants/AppConfig/AppConfigProvider';

interface OverflowMenuProps {
  hasResume: boolean;
  hasCoverLetter: boolean;
  hasSelectionCriteria: boolean;
  jobId: string;
  prospectId: number;
  statusQueryString: string | undefined;
  onClickResumeDownload: () => void;
  onClickCoverLetterDownload: () => void;
  onClickSelectionCriteriaDownload: () => void;
  onClickEmailCandidate: () => void;
}

export const CandidateRowOverflowMenu: FC<OverflowMenuProps> = ({
  hasCoverLetter,
  hasResume,
  hasSelectionCriteria,
  jobId,
  prospectId,
  statusQueryString,
  onClickResumeDownload,
  onClickCoverLetterDownload,
  onClickSelectionCriteriaDownload,
  onClickEmailCandidate,
}) => {
  const { t } = useTranslations(translations);
  const { router } = useAppConfig();

  return (
    <OverflowMenu label={t('Actions')} data={{ testid: 'candidate-actions' }}>
      {hasCoverLetter && (
        <MenuItem onClick={onClickCoverLetterDownload}>
          {t('Download cover letter')}
        </MenuItem>
      )}
      {hasResume && (
        <MenuItem onClick={onClickResumeDownload}>
          {t('Download resumé')}
        </MenuItem>
      )}
      {hasSelectionCriteria && (
        <MenuItem onClick={onClickSelectionCriteriaDownload}>
          {t('Download selection criteria')}
        </MenuItem>
      )}
      <MenuItemLink
        href={router.candidates({
          jobid: jobId,
          selected: prospectId.toString(),
          tab: JOB_APPLICATION_TAB.EMAILS,
          s: statusQueryString,
        })}
        onClick={onClickEmailCandidate}
      >
        {t('Email candidate')}
      </MenuItemLink>
    </OverflowMenu>
  );
};
